import { useSuperMutation, useSuperQuery } from '@vadiun/react-hooks-legacy';
import { businessSectorsService } from '../services/businessSectorService';

export const useBusinessSectors = () => {
  const BusinessSectorsService = businessSectorsService();
  const getSectors = useSuperQuery(
    () => BusinessSectorsService.getSectors(),
    {
      showSpinner: true
    },
    []
  );

  const addSector = useSuperMutation(businessSectorsService().addSector, {
    onMutationFinish(state, arg) {
      getSectors.reload();
    },
    messages: {
      success: {
        message: 'El Rubro fue creado con exito'
      }
    }
  });

  const editSector = useSuperMutation(businessSectorsService().editSector, {
    onMutationFinish(state, arg) {
      getSectors.reload();
    },
    messages: {
      success: {
        message: 'El Rubro fue editado con exito'
      }
    }
  });

  const deleteSector = useSuperMutation(businessSectorsService().deleteSector, {
    onMutationFinish(state, arg) {
      getSectors.reload();
    },
    messages: {
      success: {
        message: 'El Rubro fue eliminado con exito'
      }
    }
  });

  return {
    sectors: getSectors.data || [],
    loading: getSectors.isLoading,
    error: getSectors.error,
    addSector,
    editSector,
    deleteSector,
    reload: getSectors.reload
  };
};
